import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import $ from 'jquery';
import {FormattedMessage} from "react-intl";

import SelectionMainSelect from './selectionMainSelect';
import {
  toggleSelectionFeatureInfo, addToCart, toggleSelectionWindow, toggleBathroomVisualizerOpen, setCameFromPage,
  togglePulseFeatureInfoQuantity, removeFromCart, changeCartFeature, changeCartItemQuantity
} from "../../actions/actionFunctions";
import {getCurrentLayout} from '../appLayout';
import Analytics from './../../analytics';
import SelectionMainSelectCategory from "./selectionMainSelectCategory";
import SelectionFooterSubParts from "./selectionFooterSubParts";
import {setMaterialsPageActiveSubStep, toggleProductNoteEditorVisible} from "../../actions/selectionFunctions";
import {setWizardConfig} from "../../actions/wizardFunctions";
import {
  addNewQuoteWithNewRoomCartItem,
  getOtherRoomCartItemThatIsAddedToCurrentQuote,
  updateQuoteRoomsForCartItems
} from "../../misc/categorySwitchingFunctions";
import {getCartItemObject} from "../../misc/helpers";
import MaterialsFooterBackButton from "../qkbPages/materialsCommon/materialsFooterBackButton";
import {renderConfirmPopup} from "../../api/api-popups";
import {ConfirmPopupTypes} from "../visComponents/constants";


class SelectionFooter extends SelectionFooterSubParts {

  static propTypes = {
    activePart: PropTypes.object,
    activeSubPart: PropTypes.object,
    activeSubType_: PropTypes.string,
    changeActivePartRelatedItem: PropTypes.func.isRequired,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.activeSubType_ !== this.props.activeSubType_
      || nextProps.updateFeatureCount !== this.props.updateFeatureCount
      || nextProps.qtActiveCategory !== this.props.qtActiveCategory
      || (nextProps.activePart && this.props.activePart && (nextProps.activePart.partName !== this.props.activePart.partName))) {
      this.setRelatedItems(nextProps)
    }
    if (nextProps.activePartRelatedItemIndex !== this.props.activePartRelatedItemIndex) {
      this.scrollToActiveSubPart(nextProps.activePartRelatedItemIndex);
      this.activateWizardAgain(nextProps);
    }
  }

  quantityIsZero = () => {
    if (!this.props.selectionInfoQuantity
      && this.props.selectionFeatureInfo && !this.props.selectionFeatureInfo.dbFeature.hideQuantity) {
      this.props.togglePulseFeatureInfoQuantity(true);
      this.props.toggleProductNoteEditorVisible(false); // exit add note mode
      const $scrollableInfoArea = $(".selection-main__info-scrollable");
      if ($scrollableInfoArea) {
        $scrollableInfoArea.animate({scrollTop: 0}, 500);
      }
      return true;
    }
    return false
  }

  getCartFeatureParentName = (activeFeature) => {
    let parentName = this.props.selectionGroup;
    if (activeFeature.getParent) {
      const subPart = activeFeature.getParent();
      parentName = subPart.getParent ? subPart.getParent().partName : subPart.partName
    }
    return parentName
  }

  getCurrentRelatedCartItems = (activeFeature, arrayToAddtoTheCart = []) => {
    if (Array.isArray(this.props.relatedGroups) && this.props.relatedGroups.length) {
      this.props.relatedGroups.forEach(relatedGroup => {
        relatedGroup.relatedFeatures.forEach(relatedFeature => {
          if (relatedFeature.cartQuantity) {
            const relatedItemCartObject = getCartItemObject(relatedFeature, relatedFeature.cartQuantity, this.props.qtActiveCategory);
            relatedItemCartObject.relatedProductParent = activeFeature;
            arrayToAddtoTheCart.push(relatedItemCartObject)
          }
        });
      });
    }
    return arrayToAddtoTheCart
  }

  handleAddCartItemClick = async (activeFeature = this.props.selectionFeatureInfo, quantity = 0, analyticsLabel = 'add-to-cart') => {
    if (this.quantityIsZero()) {
      return false;
    }

    if (this.props.cartItemEditFeature) {
      this.props.changeCartFeature(Object.assign({}, this.props.cartItemEditFeature, {
        quantity: this.props.selectionInfoQuantity,
        cartFeature: activeFeature
      }));
      const arrayToAddtoTheCart = this.getCurrentRelatedCartItems(activeFeature);
      const newCartItems = await updateQuoteRoomsForCartItems(arrayToAddtoTheCart, true);
      // console.log("newCartItems", newCartItems);
      if (newCartItems.length) {
        await this.props.addToCart(newCartItems);
      }
      this.updateCartAndGoBack('update-cart-item');
      return;
    }

    Analytics.sendClickEvent(analyticsLabel);
    if ((document.kvConfig.visualizerType === "Kitchen" || document.kvConfig.visualizerType === "KV")
      && activeFeature.partId === "top_cabinet" && activeFeature.metaData["Module"]) {
      this.props.addToCart(this.props.materialsInfoFeatureModules)
    } else {
      const cartItemObject = {
        selectionGroup: this.getCartFeatureParentName(activeFeature),
        quantity: quantity || this.props.selectionInfoQuantity || 1,
        partId: activeFeature.partId,
        cartFeature: activeFeature,
      };
      cartItemObject.fromQtCategory = this.props.qtActiveCategory;
      const arrayToAddtoTheCart = this.getCurrentRelatedCartItems(activeFeature, [cartItemObject]);
      const newCartItems = await updateQuoteRoomsForCartItems(arrayToAddtoTheCart, true);
      const otherRoomCartItem = getOtherRoomCartItemThatIsAddedToCurrentQuote(newCartItems);
      if (otherRoomCartItem) {
        renderConfirmPopup(ConfirmPopupTypes.ReplaceRoomWhenItExistsInCartButWeAddNew, {
          applyFunction: this.createNewQuoteAndAddNewCartItemAfterConfirmPopupClick.bind(this, newCartItems[0]),
          declineFunction: this.replaceOldCartItemAfterConfirmPopupClick.bind(this, otherRoomCartItem, newCartItems[0]),
        });
        return // do not go below, we are waiting response from popup
      }
      // console.log("newCartItems", newCartItems);
      await this.props.addToCart(newCartItems);
    }
    await this.executeAfterAddToCart();
  };

  createNewQuoteAndAddNewCartItemAfterConfirmPopupClick = async (newRoomCartItem) => {
    const updatedWithQuoteIndexRoomCartItem = await addNewQuoteWithNewRoomCartItem(newRoomCartItem);
    await this.props.addToCart([updatedWithQuoteIndexRoomCartItem]);
    await this.executeAfterAddToCart();
  }
  replaceOldCartItemAfterConfirmPopupClick = async (oldCartItem, newCartItem) => {
    this.props.changeCartFeature(Object.assign({}, oldCartItem, newCartItem));
    await this.executeAfterAddToCart();
  }

  executeAfterAddToCart = async () => {
    const layout = getCurrentLayout();
    await layout.updateLocalStorage();
    this.exitFeatureInfo();
    if (!(this.props.cameFromPage === "shoppingcart" || this.props.cameFromPage === "visualizer")
      && !this.props.showAdvancedQuoting) {
      this.changeRelatedItem(this.props.activePartRelatedItemIndex + 1, "addToCartButton");
    }
  };

  handleAddRowItemsClick = async () => {
    const layout = getCurrentLayout();
    Analytics.sendClickEvent("add-row-cart-items");
    if (this.props.rowItems.length) {
      let newCartItems = await updateQuoteRoomsForCartItems([...this.props.rowItems.filter(rItem => {
        delete rItem.showRowRelatedItems; // we don't need it in the cart
        return rItem.quantity
      })], true);
      if (this.props.cartItemEditFeature) {
        newCartItems = newCartItems.filter(cartItem => {
          if (this.props.cartItemEditFeature.cartFeature.dbFeature.id === cartItem.cartFeature.dbFeature.id) {
            this.props.changeCartFeature(Object.assign({}, this.props.cartItemEditFeature, {
              quantity: cartItem.quantity,
            }));
            return false
          }
          return true
        })
      }
      await this.props.addToCart(newCartItems);
    }
    await layout.updateLocalStorage();
    this.changeRelatedItem(this.props.activePartRelatedItemIndex + 1);
  };

  handleSelectItem = () => {
    const activeFeature = this.props.selectionFeatureInfo || this.props.activeFeature;
    const quantity = this.props.selectionFeatureInfo
      ? this.props.selectionInfoQuantity || 1
      : this.props.advancedQuotingSearchItem ? this.props.advancedQuotingSearchItem.quantity : 1;

    if (this.quantityIsZero()) {
      return false;
    }

    if (this.props.advancedQuotingSearchItem) {
      // if (this.props.advancedQuotingSearchItem && activeFeature
      //   && (this.props.advancedQuotingSearchItem.cartFeature.dbFeature.id !== activeFeature.dbFeature.id)) { // removed this logic, cause we always need to remove old item
      this.props.changeCartFeature(Object.assign({}, this.props.advancedQuotingSearchItem, {
        quantity,
        cartFeature: activeFeature
      }));
      this.updateCartAndGoBack('select-advanced-quoting-item');
    } else {
      this.handleAddCartItemClick(activeFeature, quantity, 'select-advanced-quoting-item');
      hashHistory.push("/shoppingcart");
    }
  };

  updateCartAndGoBack = (analyticsLabel) => {
    Analytics.sendClickEvent(analyticsLabel);
    const layout = getCurrentLayout();
    layout.updateLocalStorage();
    hashHistory.push("/shoppingcart");
  };

  exitFeatureInfo = (footerButtonCick) => {
    this.props.toggleSelectionFeatureInfo(null);
    if (footerButtonCick) {
      this.props.setCameFromPage("materials"); // no more visualizer or shoppingcart switch
    }
  };

  handleFooterButtonClick = (index) => {
    Analytics.sendClickEvent('exit-feature-info');
    this.changeRelatedItem(index);
    if (this.props.selectionFeatureInfo) {
      this.exitFeatureInfo(true);
    }
    const {activeSubPart, wizardConfig, setWizardConfig} = this.props;
    if (activeSubPart && wizardConfig.length) {
      const existingWizSetupIndex = wizardConfig.findIndex(wizObject => {
        return wizObject.featureGroupName === activeSubPart.part.dbName || wizObject.featureGroupName === activeSubPart.part.partName
      });
      if (wizardConfig[existingWizSetupIndex]) {
        setWizardConfig([...wizardConfig.map((wizObject, wizObjectIndex) => {
          if (existingWizSetupIndex === wizObjectIndex) {
            wizObject.isFinished = !wizObject.isFinished;
          }
          return wizObject
        })]);
      }
    }
  };

  activateWizardAgain = (nextProps) => {
    if (nextProps.wizardConfig.length && nextProps.wizardConfig.some(wizObject => wizObject.isFinished)) {
      const wizardConfig = nextProps.wizardConfig.map(wizObject => {
        wizObject.isFinished = false;
        return wizObject
      })
      this.props.setWizardConfig([...wizardConfig]);
    }
  }

  canGoToFeatureInfo = () => {
    if (!this.props.selectionFeatureInfo && this.props.activeFeature) {
      const parent = this.props.activeFeature.getParent();
      const layout = getCurrentLayout();
      const navItems = layout.designNavigationItems({part: parent}, {}, "", false, true);
      const featureInQuotingTool = navItems.some(navItem => navItem.part.dbFeature.id === this.props.activeFeature.dbFeature.id);
      if (featureInQuotingTool && (!this.props.activeFeature.notAvailableInVisualizer || parent.firstClick[this.props.activeQuoteIndex])) {
        return true
      }
    }
    return false
  };

  handleNextButtonClick = () => {
    Analytics.sendClickEvent('feature-info-next');
    this.props.setCameFromPage("materials"); // no more visualizer or shoppingcart switch
    if (!this.checkForSubStepChange("next")) {
      if (this.canGoToFeatureInfo()) {
        this.props.toggleSelectionFeatureInfo(this.props.activeFeature);
      } else {
        this.exitFeatureInfo();
        this.changeRelatedItem(this.props.activePartRelatedItemIndex + 1, "nextButton");
      }
    }
  };

  renderFooterSelect = () => {
    const layout = getCurrentLayout();
    if (layout.qtCategories && this.props.qtActiveCategory) {
      if (layout.qtCategories.length > 1) {
        return (
          <div className="selection-footer-buttons__select">
            <SelectionMainSelectCategory type={2}
                                         relatedItems={this.state.relatedItems}
                                         relatedItemClick={this.handleFooterButtonClick}/>
          </div>
        )
      }
      return null
    } else {
      return (
        <div className="selection-footer-buttons__select">
          <SelectionMainSelect type={2}
                               relatedItems={this.state.relatedItems}
                               parentItems={layout.designNavigationItems()}
                               relatedItemClick={this.handleFooterButtonClick}/>
        </div>
      )
    }
  };

  setCurrentWizardStepFinished = (isFinished) => {
    const {activeSubPart, wizardConfig, setWizardConfig} = this.props;
    const existingWizSetupIndex = wizardConfig.findIndex(wizObject => {
      return wizObject.featureGroupName === activeSubPart.part.dbName || wizObject.featureGroupName === activeSubPart.part.partName
    });
    if (wizardConfig[existingWizSetupIndex]) {
      wizardConfig[existingWizSetupIndex].isFinished = isFinished;
      setWizardConfig([...wizardConfig]);
    } else {
      this.changeRelatedItem(this.props.activePartRelatedItemIndex + 1) // go next(just in case)
    }
  }

  checkForSubStepChange = (direction) => {
    const {activeSubPart, wizardConfig} = this.props;
    if (!activeSubPart || !wizardConfig.length) {
      return false
    }
    const existingWizSetup = wizardConfig.find(wizObject => {
      return wizObject.featureGroupName === activeSubPart.part.dbName || wizObject.featureGroupName === activeSubPart.part.partName
    });
    if (!existingWizSetup || !existingWizSetup.filterGroups.length || existingWizSetup.isFinished || !existingWizSetup.enableForQuoting) {
      return false
    }
    if (direction === "back") {
      const newStep = this.props.activeSubStep - 1;
      newStep < 0
        ? this.changeRelatedItem(this.props.activePartRelatedItemIndex - 1) // go back
        : this.props.setMaterialsPageActiveSubStep(this.props.activeSubStep - 1);
    } else {
      const newStep = this.props.activeSubStep + 1;
      newStep >= existingWizSetup.filterGroups.length
        ? this.setCurrentWizardStepFinished(true)
        : this.props.setMaterialsPageActiveSubStep(this.props.activeSubStep + 1);
    }
    return true
  };

  changeRelatedItem = (nextIndex, fromButton = "") => {
    this.props.changeActivePartRelatedItem(nextIndex, fromButton);
    this.props.setMaterialsPageActiveSubStep(0); //default subStep to 0 on relatedItem change
  };

  render() {
    const {fabricatorSettings, selectionFeatureInfo, showAdvancedQuoting, activeFeature, selectionWindowView,
      cartItemEditFeature} = this.props;
    // const isAddToCartButtonVisible =
    //   this.props.selectionFeatureInfo &&
    //   ((fabricatorSettings.showPricing
    //   && (this.props.selectionFeatureInfo.dbFeature.unlocked || this.props.isPhoneNumberValidated)) || !(fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)));

    const addToCartTranslate = cartItemEditFeature
      ? selectionFeatureInfo ? "quotingTool.footer.updateCartButton": "shoppingCart.featureInCartEditLink"
      : "quotingTool.footer.addToCartButton";

    const rowIsActive = selectionWindowView === 4;

    return (
      <div className="selection-footer">
        {this.getSubPartsList()}
        <div className="selection-footer-buttons">
          <MaterialsFooterBackButton checkForSubStepChange={this.checkForSubStepChange} subStepChange={() => {
            this.changeRelatedItem(this.props.activePartRelatedItemIndex - 1)
          }}/>
          {!selectionFeatureInfo && !showAdvancedQuoting ? this.renderFooterSelect() : null}
          {(selectionFeatureInfo && !showAdvancedQuoting) || rowIsActive ? (
            <button className={"selection-footer-buttons__button selection-footer-buttons__button--next"}
                    onClick={this.handleNextButtonClick}>
              <FormattedMessage id={
                selectionFeatureInfo ? "quotingTool.footer.skipButton" : "quotingTool.footer.nextButton"
              }/>
            </button>
          ) : null}
          {!selectionFeatureInfo && !showAdvancedQuoting && !rowIsActive ? (
            <button className={"ui-button3 ui-button3--green ui-button3--next pulsating--green"}
                    onClick={this.handleNextButtonClick}>
              <FormattedMessage id={cartItemEditFeature ? addToCartTranslate : "quotingTool.footer.nextButton"}/>
            </button>
          ) : null}
          {rowIsActive && !showAdvancedQuoting && !selectionFeatureInfo ? (
            <button className="selection-footer-buttons__cart ui-button2 ui-button2--green ui-button2--cart pulsating--green"
                    onClick={() => this.handleAddRowItemsClick()}>
              <FormattedMessage id={cartItemEditFeature ? "quotingTool.footer.updateCartButton" : "quotingTool.footer.addToCartButton"}/>
            </button>
          ) : null}
          {(selectionFeatureInfo && fabricatorSettings.checkout && !showAdvancedQuoting) ? (
              <button className="selection-footer-buttons__cart ui-button2 ui-button2--green ui-button2--cart pulsating--green"
                      onClick={() => this.handleAddCartItemClick()}>
                <FormattedMessage id={addToCartTranslate}/>
              </button>
          ) : null}
          {(activeFeature && fabricatorSettings.checkout && showAdvancedQuoting) ? (
              <button className="selection-footer-buttons__cart ui-button2 ui-button2--green pulsating--green"
                      onClick={this.handleSelectItem}>
                <FormattedMessage id="quotingTool.footer.selectItem"/>
              </button>
          ) : null}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {selectionGroup, selectionFeatureInfo, selectionInfoQuantity, activeFeature,
    materialsInfoFeatureModules, activePartRelatedItemIndex, relatedGroups, activeSubStep, rowItems, selectionWindowView} = store.selectionState;
  const {showAdvancedQuoting, advancedQuotingSearchItem} = store.advancedQuotingState;
  const {cameFromPage, cartItemEditFeature} = store.cartState;
  const {wizardConfig} = store.wizardState;
  const {windowWidth, visualizersLoaded, networkConnection} = store.serverState;
  const {activeQuoteIndex} = store.quotesState;
  return {
    selectionWindowView,
    selectionGroup,
    selectionFeatureInfo,
    selectionInfoQuantity,
    activeFeature,
    materialsInfoFeatureModules,
    activePartRelatedItemIndex,
    relatedGroups,
    activeSubStep,
    // isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    cameFromPage,
    fabricatorSettings: store.fabricatorState.settings,
    qtActiveCategory: store.qtState.qtActiveCategory,
    windowWidth,
    /*** subparts ***/
    // selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    cartItems: store.cartState.cartItems,
    // activeFeature: store.selectionState.activeFeature,
    updateFeatureCount: store.selectionState.updateFeatureCount,
    // activePartRelatedItemIndex: store.selectionState.activePartRelatedItemIndex,
    // qtActiveCategory: store.qtState.qtActiveCategory,
    visualizersLoaded,
    networkConnection,
    /*** subparts end ***/
    activeQuoteIndex,
    showAdvancedQuoting,
    advancedQuotingSearchItem,
    cartItemEditFeature,
    rowItems,
    wizardConfig
  };
};

export default connect(mapStateToProps, {
  toggleSelectionFeatureInfo,
  toggleSelectionWindow,
  toggleBathroomVisualizerOpen,
  addToCart,
  removeFromCart,
  setCameFromPage,
  togglePulseFeatureInfoQuantity,
  setMaterialsPageActiveSubStep,
  toggleProductNoteEditorVisible,
  changeCartFeature,
  changeCartItemQuantity,
  setWizardConfig,
})(SelectionFooter);
